<template>
  <div id="chat" v-if="roomExists" key="room">
    <transition-group
      name="chat"
      tag="div"
      class="list content"
    >
      <v-row no-gutters
        v-for="{ key, owner, name, image, message } in chat"
        :key="key"
        class="item"
      >
        <v-col
          v-if="user.uid != owner"
          cols="2" sm="1" md="1">
          <div class="item-image">
            <img
              :src="image"
              width="40"
              height="40"
            >
          </div>
          <div class="item-name">
            {{ name }}
          </div>
        </v-col>
        <v-col
          cols="10" sm="11" md="11"
          :class="'msg' + msgSelf(owner)">
          <div :class="'item-detail' + msgSelf(owner)">
            <div v-if="message.startsWith('https:\/\/firebasestorage.googleapis.com\/v0\/b\/vue-chat-17a86.appspot.com\/o\/')" class="item-picture">
              <img :src="message" height="200px"/>
            </div>          
            <div v-else :class="'item-message' + msgSelf(owner)">
              <nl2br
                tag="div"
                :text="message"
              />
            </div>
          </div>
        </v-col>  
        <v-col
          v-if="user.uid == owner"
          cols="2" sm="1" md="1">
          <div class="item-image">
            <img
              :src="image"
              width="40"
              height="40"
            >
          </div>
          <div class="item-name">
            {{ name }}
          </div>
        </v-col>
      </v-row>
    </transition-group>

    <form
      action=""
      class="form"
      @submit.prevent="doSend"
    >
      <v-card
        tile
        elevation="3">  
        <v-row class="chat_form" no-gutters>
          <v-col
            cols="1" sm="1" md="2"
          >
            <v-file-input
              @change="selectFile"
              accept="image/*"
              label="ファイルを送信"
            ></v-file-input>
              <!-- <div id="errArea"> {{ infoMsg }}</div> あとでアラート出る形にする-->          
          </v-col>          
          <v-col
            cols="9" sm="9" md="7"
            class=""
          >
            <v-textarea
              class="d-none d-sm-flex mx-5"
              rows="2"
              no-resize
              outlined
              filled
              counter="200"
              :rules="rules"
              v-model="input"
              @keypress.enter.exact.prevent="doSend"        
            >
            </v-textarea>
            <v-textarea
              class="d-flex d-sm-none pr-2"
              rows="2"
              no-resize
              outlined
              filled
              counter="200"
              :rules="rules"
              v-model="input"
              @keypress.enter.exact.prevent="doSend"        
            >
            </v-textarea>
          </v-col>
          <v-col
            cols="1" sm="2" md="3"
          >
            <v-btn
              x-large
              class="send-button d-none d-sm-flex"
              type="submit"
              color="#151b1c"
            >
              送信
            </v-btn>
            <v-btn
              class="send-button-xs d-flex d-sm-none"
              type="submit"
              color="#151b1c"
            >
              送信
            </v-btn>
          </v-col>  
        </v-row>
      </v-card>     
    </form>

  </div>
  <div id="app" v-else key="noroom">
    <NoRoom/>
  </div>
</template>

<script>
import firebase from 'firebase'
import Firebase from './../firebase'
// 改行を <br> タグに変換するモジュール
import Nl2br from 'vue-nl2br'
import NoRoom from '@/components/NoRoom.vue'
import { mapState } from 'vuex'
import $ from 'jquery'
export default {
  components: { Nl2br, NoRoom },
  data() {
    return {
      chat: [], // 取得したメッセージを入れる配列
      input: '', // 入力したメッセージ
      infoMsg: null,
      rules: [v => v.length <= 200 || '200文字まで入力できます。'],
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    roomExists() {
      let rooms = 0
      this.$store.getters.getRooms.forEach(room => {
        if (room.key == this.$route.params.id) rooms++
      })  
      if(rooms === 0) return false
      else return true
    },
  },  
  cerated (){
  },
  mounted() {
    // fixedされたformの幅を調整するため、DOM描画後にも処理する。
    this.$nextTick(()=> {
      $(".form").width($("#chat").width())
      this.Refresh(this.$route.params.id)
    })
  },
  methods: {
    Refresh (path) {
      $(".form").width($("#chat").width())
      const user = this.$store.getters.user
      const ref_message = firebase.database().ref('message/'+path)
      if (user) {
        this.chat = []
        ref_message.off()
        // message に変更があったときのハンドラを登録
        ref_message.limitToLast(10).on('child_added', this.messageAdded) 
      } else {
        // message に変更があったときのハンドラを解除
        ref_message.limitToLast(10).off('child_added', this.messageAdded)
      }
    },
    // ログイン処理
    doLogin () {
      const provider = new firebase.auth.TwitterAuthProvider()
      firebase.auth().signInWithPopup(provider)
    },
    // ログアウト処理
    doLogout () {
      firebase.auth().signOut()
    },
    // スクロール位置を一番下に移動
    scrollBottom () {
      this.$nextTick(() => {
        window.scrollTo(0, document.body.clientHeight)
      })
    },
    messageAdded (snap) {
      const message = snap.val()
      this.chat.push({
        key: snap.key,
        owner: message.owner,
        name: message.name,
        image: message.image,
        message: message.message
      })
      this.scrollBottom()
    },
    doSend () {
      if(this.input.length <= 200){
        const user = this.$store.getters.user
        if (user.uid && this.input.length) {
          const image = user.photoURL == null ? 'https://abs.twimg.com/sticky/default_profile_images/default_profile_normal.png' : user.photoURL
          const name = user.displayName == null ? '名無し' : user.displayName
          firebase.database().ref('message/'+this.$route.params.id).push({
            message: this.input,
            owner: user.uid,
            name: name,
            image: image
          }, () => {
            this.input = ''
          })            
        }        
      }
    },
    selectFile (file) {
      const user = this.$store.getters.user
      var storageRef = firebase.storage().ref().child(Date.now() + file.name)
      const image = user.photoURL == null ? 'https://abs.twimg.com/sticky/default_profile_images/default_profile_normal.png' : user.photoURL
      const name = user.displayName == null ? '名無し' : user.displayName
      storageRef.put(file)
      .then(snap => {
        storageRef.getDownloadURL().then(url => {
          firebase.database().ref('message/'+this.$route.params.id).push({
            message: url,
            owner: user.uid,
            name: name,
            image: image
          })
        }).catch(error => {
          this.infoMsg = error
        })       
      })
      .catch(error => {
        this.infoMsg = error
      })
    },
    msgSelf(owner){
      if(owner == this.$store.getters.user.uid){
        return '-self'
      }
      else return ''
    },
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  box-sizing: border-box;
}
#chat{
  margin-top: 15px;
}
.content {
  margin: 0 auto;
  padding: 0 10px;
  max-width: 600px;
}
.form {
  display: flex;
  position:fixed;
  left: 0;
  bottom: 0;
}
.chat_form{
  margin: auto;
  max-width:1100px;
}
.v-card{
  padding-top: 23px;  
  width: 100%; 
}
.v-textarea{
}
.list {
  margin-bottom: 150px;
}
.msg{
  padding-bottom: 9px !important;
  padding-left:15px !important;
}
.msg-self{
  text-align: right;
  padding-bottom: 9px !important;
}
.msg-div-self{
  text-align:left !important;
}
.item {
  position: relative;
  display: flex;
  align-items: flex-end;
  margin-bottom: 1.5em;
}
.item-image{
  text-align: center !important;
}
.item-image img {
  border-radius: 20px;
  vertical-align: top;
}
.item-detail {
  margin: 0 0 0 1.4em;
}
.item-detail-self {

  margin: 0 2em 0 0;
}
.item-name {
  text-align: center;
  font-size: 75%;
}
.item-message {
  word-break: break-all;
  position: relative;
  display: inline-block;
  padding: 0.8em;
  background: #deefe8;
  border-radius: 6px;
  line-height: 1.2em;
}
.item-message::before {
  position: absolute;
  content: " ";
  display: block;
  left: -16px;
  bottom: 8px;
  border: 4px solid transparent;
  border-right: 12px solid #deefe8;
}
.item-message-self {
  word-break: break-all;
  position: relative;
  display: inline-block;
  padding: 0.8em;
  background: #deefe8;
  border-radius: 6px;
  line-height: 1.2em;
}
.item-message-self > div{
  text-align:left;
}
.item-message-self::before {
  position: absolute;
  content: " ";
  display: block;
  right: -16px;
  bottom: 8px;
  border: 4px solid transparent;
  border-left: 12px solid #deefe8;
}
.v-file-input > .v-input__control{
   display:none;
}
.v-file-input{
    display: block !important;
    text-align: right !important;
    padding:0 !important;
    margin:0 !important;
}
.v-input__prepend-outer{
  margin:3px 0 !important;
}
.send-button {
  margin-top: 5px !important;
  color: white !important;
  font-weight: bold;
}
.send-button-xs{
  margin-top: 3px !important;
  height:58px !important;
  color: white !important;
  font-weight: bold;
}
/* トランジション用スタイル */
.chat-enter-active {
  transition: all 1s;
}
.chat-enter {
  opacity: 0;
  transform: translateX(-1em);
}
</style>
